<div
  class="flex flex-col select-none"
  [ngStyle]="{'height.px': colHeight}"
  [ngClass]="{'highlight': selected, 'bg-orange-400': day?.isFiltered}"
  (click)="selectBooking()"
  #bookingRef>
  <div class="h-full hover:bg-gray-200" *ngIf="day; else itemVal">
    <div class="h-full p-4 cursor-pointer">
      <div class="flex justify-end h-11">
        <h3
          id="date"
          class="pb-0 mb-0 font-medium"
          [ngClass]="today ? 'flex w-9 h-9 m-[-4px] items-center justify-center rounded-full bg-brand-bright-orange text-white' : pastDay ? 'text-gray-600' : 'text-orange-900'">
          {{day.date | date:'dd'}}
        </h3>
      </div>
      <ng-container #container></ng-container>
      <div class="flex justify-end" *ngIf="day.items.length > 2">
        <p class="p-0 mb-0 font-bold">{{day.items.length - 2}} {{'global.more' | translate}}</p>
      </div>
    </div>
  </div>
</div>

<ng-template #itemVal>
  <div class="flex flex-col p-4">
    <h3 class="text-right text-gray-800 font-medium">{{item.weekNumber || item}}</h3>
    <p class="text-right mb-1 ">
      {{weekRange[0]}}
      <span *ngIf="weekRange.length > 1">-</span>
    </p>
    <p class="text-right " *ngIf="weekRange.length > 1">{{weekRange[1]}}</p>
  </div>
</ng-template>
